import React from "react";
import "./snow.scss";

interface SnowProps {
  flakeCount?: number;
}

export default class Snow extends React.Component<SnowProps, any> {
  static defaultProps = {
    flakeCount: 50
  };

  render() {
    const { flakeCount } = this.props;
    const flakes = [];

    for (let i = 0; i < flakeCount!; i++) {
      const style = {
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 10}s`,
        animationDuration: `${8 + Math.random() * 12}s`,
        opacity: 0.3 + Math.random() * 0.7,
        fontSize: `${6 + Math.random() * 12}px`,
      };

      flakes.push(
        <span key={i} className="snowflake" style={style}>
          ❄
        </span>
      );
    }

    return <div className="snow-container">{flakes}</div>;
  }
}
